// extracted by mini-css-extract-plugin
export default {"flag":"Flag_flag__p+DxY"};